import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import VueJWT from 'vuejs-jwt'
import VueSession from 'vue-session'
import VueHtmlToPaper from 'vue-html-to-paper'
import VueMeta from 'vue-meta'
import lsWatcher from 'vue-storage-watcher'
import VueTelInput from 'vue-tel-input'
import VueSignaturePad from 'vue-signature-pad'
import VueLazyLoad from 'vue-lazyload'
import 'vue-advanced-cropper/dist/style.css'
import PerfectScrollbar from 'vue2-perfect-scrollbar'
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css'
import App from './App.vue'

// cryptojs
import VueCryptojs from 'vue-cryptojs'
Vue.use(VueCryptojs)

// routers
import router from './routes'

require('vue-image-lightbox/dist/vue-image-lightbox.min.css')

Vue.config.productionTip = false
Vue.use(Vuetify)
Vue.use(VueJWT)
Vue.use(VueSession, {
    persist: true
})
Vue.use(VueHtmlToPaper, {
    styles: [
        'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css'
    ]
})
Vue.use(VueMeta)
Vue.use(lsWatcher, { prefix: 'tuguecrmuser' })
Vue.use(VueTelInput)
Vue.use(VueSignaturePad)
Vue.use(VueLazyLoad)
Vue.use(PerfectScrollbar)

Vue.mixin({
    data: function() {
        return {
            get jwtsecret() {
                return '-E@c0mM2o2o-'
            },
            get domain() {
                // return 'http://35.220.187.169:8181'
                return `https://egov.tuguegaraocity.gov.ph:8181`
                // return `${window.location.protocol}//${window.location.hostname}:8181`
            },
            get localdomain() {
                // ngrok
                // return `https://${window.location.hostname}/#/`
                // local
                // return `http://${window.location.hostname}:8080/#/` 
                // return 'https://11dc69002aa1.ngrok.io/#/'
                // return `${window.location.protocol}//${window.location.hostname}/Dev/#/`
                return `${window.location.protocol}//${window.location.hostname}/#/`
            },
            get treasuryapi() {
                return `https://egov.tuguegaraocity.gov.ph/Treasury`
                // return `${window.location.protocol}//${window.location.hostname}/Treasury/APIS/`
            },
            get onlinepaymentpass() {
                return `Tugu30LP@ym3nt`
            },
            get version() {
                return '266f89f4-c9b9-4981-b446-afbe7b7f8a43'
            }
        }
    }
})

new Vue({
    router,
    vuetify: new Vuetify({}),
    render: h => h(App),
}).$mount('#app')
